// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .global-search.has-icon input[type=search][data-v-4d579cc0]{padding-left:2.5rem!important;overflow:hidden;text-overflow:ellipsis}#openbay .category-display[data-v-4d579cc0]{font-size:13px;text-align:justify;float:right;color:#616a76;font-family:Whitney}#openbay .search-item[data-v-4d579cc0]{font-weight:500;margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
